<script>
import { chessboard } from "vue-chessboard";

export default {
  name: "ViewerChessboard",

  extends: chessboard,

  mounted() {
    this.board.set({
      movable: {
        viewOnly: true,
      },
    });
  },
};
</script>
